import React, { Suspense, useEffect } from 'react';
import { Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import SvgLoader from 'project-components/SvgLoader/SvgLoader';
import Layout from '../components/layout/layout.jsx';

import styles from './App.scss';
import routes from '../routes';

const App = ({ calendarSettings }) => {
  const history = useHistory();
  let { pathname, search } = useLocation();
  useEffect(() => {
    const pageName = new URL(document.location).searchParams.get('page');
    if (pageName) {
      const searchSplit = search.split('&');
      const pathName = searchSplit[0].slice(6);
      const searchPart = searchSplit.slice(1).join('&');
      if (pathname.includes('/appointments')) {
        history.replace({
          pathname: `${config.urls.baseUrl}/appointments/${pathName}`,
          search: searchPart || '',
        });
        return;
      }
      history.replace({
        pathname: `${config.urls.baseUrl}/${pathName}`,
        search: searchPart || '',
      });
    }
  }, []);
  return (
    <Layout>
      <Suspense
        fallback={
          <div className={styles.Suspense}>
            <SvgLoader size={'3.5rem'} />
          </div>
        }
      >
        <Switch>
          {routes.map(route => (
            <Route key={route.path} {...route} />
          ))}
          <Redirect
            exact
            from='/'
            to={`${config.urls.baseUrl}/${config.calendar.initialDate}?worker_id=${calendarSettings.activeWorkerId}&calendar_view_type=${config.calendar.initialView}`}
          />
        </Switch>
      </Suspense>
    </Layout>
  );
};

const mapStateToProps = state => ({
  calendarSettings: state.calendar.calendarSettings,
});

export default connect(mapStateToProps, null)(App);
